// src/pages/UserReportsTab.js
import React, { useState, useEffect } from 'react';

export default function UserReportsTab() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token');

  const q = search.trim().toLowerCase();
  const visibleUsers = q
    ? users.filter(u =>
        [u.email, u.first_name, u.last_name]
          .filter(Boolean)
          .some(v => String(v).toLowerCase().includes(q))
      )
    : users;

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const resp = await fetch('/api/dashboard/users/', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        if (!resp.ok) throw new Error('Error loading users list');
        const data = await resp.json();
        setUsers(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [token]);

  const downloadReport = async (userId, email) => {
    try {
      const resp = await fetch(`/api/users/${userId}/transactions/export/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!resp.ok) throw new Error(`Error downloading report: ${resp.statusText}`);
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `transactions_${email}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow overflow-x-auto">
      <h3 className="text-2xl font-semibold mb-4">User Reports</h3>

      <input
        type="text"
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder="Search by email or name"
        className="border p-2 w-full mb-4 focus:outline-none focus:ring-2 focus:ring-[#0F2C5E]"
      />
      {!loading && !error && q && (
        <p className="text-xs text-gray-500 mb-2">
          {visibleUsers.length} of {users.length} users match
        </p>
      )}

      {loading ? (
        <p>Loading…</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <table className="min-w-full text-sm">
          <thead className="border-b bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">First Name</th>
              <th className="px-4 py-2 text-left">Last Name</th>
              <th className="px-4 py-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {visibleUsers.map(u => (
              <tr key={u.id} className="border-b hover:bg-gray-100">
                <td className="px-4 py-2">{u.email}</td>
                <td className="px-4 py-2">{u.first_name}</td>
                <td className="px-4 py-2">{u.last_name}</td>
                <td className="px-4 py-2 text-center">
                  <button
                    onClick={() => downloadReport(u.id, u.email)}
                    className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700 transition"
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))}

            {visibleUsers.length === 0 && (
              <tr>
                <td colSpan="4" className="py-4 text-center text-gray-500">
                  {q ? 'No users match your search' : 'No users'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
